import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DossierHistoriqueComponent } from './dossier-historique/dossier-historique.component';
import { CreateDossierCreditComponent } from './formulaire/createform/create-dossier-credit/create-dossier-credit.component';
import { DossierInfoComponent } from './dossier-info/dossier-info.component';
import { DossierUpdateComponent } from './dossier-update/dossier-update.component';
import { UpdateDossierInfoComponent } from './dossier-update/form/update-dossier-info/update-dossier-info.component';
import { DossierHistoriqueNewComponent } from './dossier-historique-new/dossier-historique-new.component';
import { FormScanPieceComponent } from './formulaire/taskform/form-scan-piece/form-scan-piece.component';
import { FormulaireLayoutComponent } from './formulaire/formulaire-layout/formulaire-layout.component';
import { FormAjouterRapportAnalyseComponent } from '../formulaire/form/form-ajouter-rapport-analyse/form-ajouter-rapport-analyse.component';
import { FormAnalyseDossierComponent } from '../formulaire/form/form-analyse-dossier/form-analyse-dossier.component';
import { FormEmissionAvisDossierComponent } from '../formulaire/form/form-emission-avis-dossier/form-emission-avis-dossier.component';
import { FormAffectationDossierComponent } from '../formulaire/form/form-affectation-dossier/form-affectation-dossier.component';
import { FormValidationTravauxAnalyseDirEngComponent } from './formulaire/taskform/form-validation-travaux-analyse-dir-eng/form-validation-travaux-analyse-dir-eng.component';
import { FormPreparationComiteInterneCreditComponent } from '../formulaire/form/form-preparation-comite-interne-credit/form-preparation-comite-interne-credit.component';
import { FormSignerRapportAnalyseComponent } from '../formulaire/form/form-signer-rapport-analyse/form-signer-rapport-analyse.component';
import { FormMisEnPlaceComponent } from './formulaire/taskform/form-mis-en-place/form-mis-en-place.component';
import { FormGenerationLettreNotificationComponent } from './formulaire/taskform/form-generation-lettre-notification/form-generation-lettre-notification.component';
import { FormVerificationConditionSuspensiveComponent } from './formulaire/taskform/form-verification-condition-suspensive/form-verification-condition-suspensive.component';
import { FormGenerationFicheMiseEnPlaceComponent } from './formulaire/taskform/form-generation-fiche-mise-en-place/form-generation-fiche-mise-en-place.component';
import { FormEmissionAccordDossierComponentComponent } from '../formulaire/form/form-emission-accord-dossier-component/form-emission-accord-dossier-component.component';
import { FormPreparationComiteSuperieurCreditComponent } from '../formulaire/form/form-preparation-comite-superieur-credit/form-preparation-comite-superieur-credit.component';
import { FormAnalyseDossierEmissionAvisComponent } from '../formulaire/form/form-analyse-dossier-emission-avis/form-analyse-dossier-emission-avis.component';
import { FormAjoutRapportEmissionAvisComponent } from '../formulaire/form/form-ajout-rapport-emission-avis/form-ajout-rapport-emission-avis.component';
import { FormMiseEnPlaceTirageComponent } from './formulaire/taskform/form-mise-en-place-tirage/form-mise-en-place-tirage.component';
import { DossierHistoriqueAllComponent } from './dossier-historique-all/dossier-historique-all.component';



const routes: Routes = [
  
  //
  {
    path: '',
    data: {breadcrumb: 'Corporate'},
    children: [
      
      {
        path:'',
        redirectTo: 'dossier-historique',
        pathMatch: 'full' 
      },
      {
        path: 'dossier-historique',
        component: DossierHistoriqueComponent,
        data: {breadcrumb: 'Historique dossier'},
      },
      {
        path: 'dossier-historique-new',
        component: DossierHistoriqueNewComponent,
        data: {breadcrumb: 'Historique dossier'},
      },
      
      {
        path: 'dossier-historique-all',
        component: DossierHistoriqueAllComponent,
        data: {breadcrumb: 'Historique dossier'},
      },
      {
        path: 'dossier-historique-all/:status/:startDate/:endDate',
        component: DossierHistoriqueAllComponent,
        data: {breadcrumb: 'Historique dossier'},
      },

      
      {
        path: 'create-dossier-credit/:workflowCode',
        component: CreateDossierCreditComponent,
        data: {breadcrumb: 'Créer un dossier de crédit'},
      },
      
      // pour renouvellement
      {
        path: "create-dossier-credit/:workflowCode/:requestIdParent",
        component: CreateDossierCreditComponent,
        data: { breadcrumb: "Créer un dossier de crédit" },
      },
      //

      {
        path: 'dossier-info/:requestId',
        component: DossierInfoComponent,
        data: {breadcrumb: 'Dossier Info'},
      },
      
      { 
        path: 'form-scan-piece/:requestId/:taskId', 
        data: {breadcrumb: 'Formulaire'},
        component: FormScanPieceComponent
      },

    ]
  },
  //

  
  //
  { 
    path: '',
    data: {breadcrumb: 'Product Program'},
    component: DossierUpdateComponent, 
    children: [
      { 
        path: 'dossier-update/:requestId/:correctionId', 
        data: {breadcrumb: 'Formulaire'},
        component: UpdateDossierInfoComponent
      }
    ]
  },
  //

  //
  { 
    path: '',
    data: {breadcrumb: 'Corporate'},
    component: FormulaireLayoutComponent, 
    children: [
      
      { 
        path: 'form-emission-avis-dossier/:requestId/:taskId', 
        component: FormEmissionAvisDossierComponent
      },
      { 
        path: 'form-verification-dossier-validation-analyse-fincanciere-ca/:requestId/:taskId', 
        component: FormAjouterRapportAnalyseComponent
      },
      { 
        path: 'form-analyse-dossier/:requestId/:taskId', 
        component: FormAnalyseDossierComponent
      },
      { 
        path: 'form-verification-dossier-validation-analyse-financiere-chef-dep-cli-ent/:requestId/:taskId', 
        component: FormAnalyseDossierEmissionAvisComponent
      },
      { 
        path: 'form-affectation-dossier-dir-ris/:requestId/:taskId', 
        component: FormAffectationDossierComponent
      },
      { 
        path: 'form-realisation-contre-analyse-financiere-risque-credit/:requestId/:taskId', 
        component: FormAjouterRapportAnalyseComponent
      },
      { 
        path: 'form-affectation-dossier/:requestId/:taskId', 
        component: FormAffectationDossierComponent
      },
      { 
        path: 'form-validation-travaux-analyse-dir-ris/:requestId/:taskId', 
        component: FormAnalyseDossierEmissionAvisComponent
      },
      { 
        path: 'form-validation-travaux-analyse-dir-eng/:requestId/:taskId', 
        component: FormValidationTravauxAnalyseDirEngComponent
      },
      { 
        path: 'form-envoi-avis-comite-conseil-admin/:requestId/:taskId', 
        component: FormEmissionAccordDossierComponentComponent
      },
      { 
        path: 'form-second-regard-convention-credit-etablie/:requestId/:taskId', 
        component: FormAnalyseDossierComponent
      },
      { 
        path: 'form-envoi-avis-comite-credit/:requestId/:taskId', 
        component: FormEmissionAccordDossierComponentComponent
      },
      { path: 'form-verification-fiche-mise-en-place/:requestId/:taskId', 
        component: FormAnalyseDossierComponent
      },
      { 
        path: 'form-affectation-dossier-dir-jur/:requestId/:taskId', 
        component: FormAffectationDossierComponent
      },
      { 
        path: 'form-affectation-dossier-chef-dep-gar/:requestId/:taskId', 
        component: FormAffectationDossierComponent
      },
      { 
        path: 'form-realisation-analyse-garantie-avis-dossier/:requestId/:taskId', 
        component: FormAjoutRapportEmissionAvisComponent
      },
      { 
        path: 'form-validation-dossier-dir-gen/:requestId/:taskId', 
        component: FormEmissionAccordDossierComponentComponent
      },
      { 
        path: 'form-preparation-comite-credit/:requestId/:taskId', 
        component: FormPreparationComiteInterneCreditComponent
      },
      { 
        path: 'form-generation-lettre-notification-2/:requestId/:taskId', 
        component: FormGenerationLettreNotificationComponent
      },
      { 
        path: 'form-validation-lettre-notification/:requestId/:taskId', 
        component: FormAnalyseDossierComponent
      },
      { 
        path: 'form-signature-lettre-notification/:requestId/:taskId', 
        component: FormSignerRapportAnalyseComponent
      },
      { 
        path: 'form-contact-client-validation-lettre-notification/:requestId/:taskId', 
        component: FormEmissionAvisDossierComponent
      },
      { 
        path: 'form-affectation-dossier-dir-jur2/:requestId/:taskId', 
        component: FormAffectationDossierComponent
      },
      { 
        path: 'form-formalisation-garantie-mise-en-place-convention/:requestId/:taskId', 
        component: FormAjouterRapportAnalyseComponent
      },
      { 
        path: 'form-validation-garantie-mise-en-place-convention-chef-dep-gar/:requestId/:taskId', 
        component: FormAnalyseDossierComponent
      },
      { 
        path: 'form-validation-garantie-mise-en-place-convention/:requestId/:taskId', 
        component: FormAnalyseDossierComponent
      },
      { 
        path: 'form-contact-client-signature-contrat-convention-credit/:requestId/:taskId', 
        component: FormEmissionAvisDossierComponent
      },
      { 
        path: 'form-verification-convention-credit-signee/:requestId/:taskId', 
        component: FormEmissionAvisDossierComponent
      },
      { 
        path: 'form-verification-condition-suspensive/:requestId/:taskId', 
        component: FormAnalyseDossierComponent
      },
      { 
        path: 'form-affectation-dossier-chef-serv-admin-credit/:requestId/:taskId', 
        component: FormAffectationDossierComponent
      },
      { 
        path: 'form-generation-fiche-mise-en-place/:requestId/:taskId', 
        component: FormGenerationFicheMiseEnPlaceComponent
      },
      { 
        path: 'form-signature-fiche-mise-en-place-credit-si/:requestId/:taskId', 
        component: FormSignerRapportAnalyseComponent
      },
      { 
        path: 'form-deblocage-fonds/:requestId/:taskId', 
        component: FormMisEnPlaceComponent
      },
      { 
        path: 'form-deblocage-fonds-tirage/:requestId/:taskId', 
        component: FormMiseEnPlaceTirageComponent
      },
      { 
        path: 'form-preparation-comite-superieur-credit/:requestId/:taskId', 
        component: FormPreparationComiteSuperieurCreditComponent
      },
      {
        path: "form-analyse-dossier-emission-avis/:requestId/:taskId",
        component: FormAnalyseDossierEmissionAvisComponent,
      },
      { 
        path: 'form-signer-rapport-analyse/:requestId/:taskId', 
        component: FormSignerRapportAnalyseComponent
      },
      { 
        path: 'form-ajouter-rapport-analyse/:requestId/:taskId', 
        component: FormAjouterRapportAnalyseComponent
      },

    ]
  }
  //
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CorporateRoutingModule { }
